import { Box, Container, Link, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import { makeStyles } from "@material-ui/core";
import { BiArrowBack } from "react-icons/bi";
import { postToHubSpot } from "../api/APIs";

const PlanNotAvailable = ({ setNotAvailable, setShowForm }) => {
  const theme = useTheme();
  const classes = useStyles();

  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    background: "#009A88",
    whiteSpace: "nowrap",
  }));

  useEffect(()=>{
    handleSendForm(true);
  },[])

  const handleSendForm = (flag) =>{
    const userInfo =  localStorage.getItem("userInfo");
    const status = flag ? "Near Miss" : "Huge Miss";
    if (userInfo) {
      const user = JSON.parse(userInfo);
      postToHubSpot(user.firstName, user.lastName, user.email, status).then((res)=>{
        console.log(res);
      })
    }
  }


  return (
    <Container>
      <Box
        // width="100%"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          // alignItems: "center",
          textAlign: 'left',
          margin:{sm:"10% 5% 10% 5%", lg :"5% 10% 10% 10%"}
        }}
      >
        <Typography
          sx={{
            fontSize: "1.4rem",
            lineHeight: { xs: "5vw", sm: "5vw", md: "5vw", lg: "3vw" },
            fontWeight: { xs: "500", sm: "500", md: "500", lg: "900" },
            color: "#00B49D",
            textTransform: "uppercase",
          }}
        // align="center"
        >
          The results
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "5.5vw", sm: "5.5vw", md: "5vw", lg: "45px" },
            color: theme.palette.primary.main,
            whiteSpace: "wrap",
            // padding: "0 15%",
          }}
          // align="center"
          variant="body2"
        // padding={{ xs: "0 10%", sm: "0 10%", md: "0 10%", lg: "0 5%" }}
        >
          Your plan is only slightly more affordable
        </Typography>
        <Typography
          //  variant="body2"
          sx={{
            fontSize: "1.1rem",
            color: "#2F2F2F",
            fontWeight: "600",
            marginBottom:'1rem'
          }}
        >
          Even though our current energy charge is a smidge more than your current plan, you stand to benefit by switching to our Bluebonnet plan.
        </Typography>

        <ul style={{ paddingLeft: "1.2rem" }}>
          {Label.map((item) => {
            return <li key={item.id}>
              <Typography
                sx={{
                  fontSize: "1.1rem",
                  color: "#2F2F2F",
                  fontWeight: "600"
                }}
              >
                <b>
                  {item.title}
                </b>
                <span className={classes.span}>
                  {item.content}&nbsp;
                </span>
                <a href={item.url} className={classes.a}>
                  {"Learn more >>"}
                </a>
              </Typography>
            </li>
          })}
        </ul>
        <Link
          underline="none"
          href={"https://enroll.bkvenergy.com/"}
          sx={{
            marginTop: "20px",
            marginBottom:"20px"
          }}
        // color="inherit"
        >
          <Button
            className={classes.button}
            sx={{
              padding: {sm:"8px 28px", lg:"18px 28px"},
              // {
              //   xs: "3% 15%",
              //   sm: "3% 15%",
              //   md: "7% 15%",
              //   lg: "13px 28px",
              // },
              minWidth: { lg: "190px" },
            }}
          >
            <Typography
              className="text"
              fontSize={{ xs: "2.5vw", sm: "2.5vw", md: "2.5vw", lg: "1.3rem" }}
              sx={{ lineHeight: "21px", fontWeight: "900"}}
            >
              SHOP FOR BLUEBONNET PLANS
            </Typography>
          </Button>
        </Link>

        <BiArrowBack
          onClick={() => {
            setShowForm(false);
            setNotAvailable(false);
          }}
          className={classes.back}
          size="40px"
          color="#009A88"
        />
      </Box>
    </Container>

  );
};

export default PlanNotAvailable;

const useStyles = makeStyles((theme) => ({
  button: {
    transition: "all .1s ease-in-out",
    outline: "3px solid #FFD27D",
    background: "#FFD27D !important",
    "&:hover": {
      // // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "#fff",
      outline: "3px solid #FFD27D",
      background: "#fff !important"
    },
  },
  back: {
    position: "absolute",
    top: "15%",
    left: "20%",
    cursor: "pointer",
  },
  a: {
    color:"#00B49D", 
    fontWeight:'800', 
    textDecoration: "underline", 
    cursor:'pointer'
  },
  span :{
    fontWeight:500
  },
  "@keyframes scale": {
    "0%": {
      transform: "scale(1, 1)",
      //animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
  "@media (max-width: 768px)": {
    back: {
      top: "10%",
      left: "0"
    },
  },
}));


const Label = [
  {
    id: 1,
    title: "30-Day Power Pilot: ",
    content: "Try the Bluebonnet plan risk-free for 30 days. If you cancel within the first 30 days, we will not charge an early termination fee.",
    url: "https://bkvenergy.com/premier-benefits/30-day-power-pilot/"
  },
  {
    id: 2,
    title: "ElectroShare Rewards: ",
    content: "Annual customer payout tied to our profits. The more we earn, the more we give back.",
    url: "https://bkvenergy.com/premier-benefits/electroshare-rewards/"
  },
  {
    id: 3,
    title: "Blend & Extend: ",
    content: "We're always searching for opportunities to lower rate in the middle of your contract. If we find one, you can switch the more affordable plan at no cost.",
    url: "https://bkvenergy.com/premier-benefits/blend-and-extend/"
  },
  {
    id: 4,
    title: "Save Now, Pay Later: ",
    content: "If finances are tight you can skip a bill and pay it over in easily manageable chunks over the next six months.",
    url: "https://bkvenergy.com/premier-benefits/save-now-pay-later/"
  },
  {
    id: 5,
    title: "Spark Alerts: ",
    content: "Severe weather notifications and relevant energy saving tips to help you reduce your electric bill and keep your family safe.",
    url: "https://bkvenergy.com/premier-benefits/spark-alerts/"
  },
  {
    id: 6,
    title: "Contract Consultation: ",
    content: "Our personalized renewal service. When it's time to renew, our expert customer support team will help you find the best possible rate for your next contract.",
    url: "https://bkvenergy.com/premier-benefits/contract-consultation/"
  }
]